/**
 * Created by andrey on 20.02.18.
 */

const WildcardBooster = function (id) {
    Booster.call(this, id);

    this.onCardCreatedListener = function () {};
};

WildcardBooster.prototype = Object.create(Booster.prototype);
WildcardBooster.prototype.constructor = WildcardBooster;

WildcardBooster.prototype.onGameStarted = function () {
    this.hintHandler = cleverapps.userStatus.on("inactive_very_short", this.hintAttempt.bind(this), this);
    cleverapps.userStatus.on("active", this.onUserActive.bind(this));
    Game.currentGame.on("stop", () => {
        this.hintHandler && this.hintHandler.clear();
    });
};

WildcardBooster.prototype.getControls = function () {
    return ["hint_4"];
};

WildcardBooster.prototype.onExecute = function () {
    const card = new Wildcard();
    this.onCardCreatedListener(card);
    Game.currentGame.shiftWildcard(card);

    Game.currentGame.log.push(MovesLog.MOVE_USE_BOOSTER, { id: this.id });

    if (!this.wildcardTutorial) {
        const msg = PseudoRandom.GET().mathChoose(cleverapps.exclamation.getCongratulations());
        cleverapps.exclamation.show(msg);
    }
};

WildcardBooster.prototype.activateTutorial = function () {
    this.wildcardTutorial = true;
    this.setFreePrice();
};

WildcardBooster.prototype.deactivateTutorial = function () {
    this.wildcardTutorial = false;
    this.setRegularPrice();
};

WildcardBooster.prototype.use = function (useType) {
    if (!this.wildcardTutorial) {
        BaseBooster.prototype.use.call(this, useType);
    }
};

WildcardBooster.prototype.onPressed = function (f, isRunningForce) {
    Booster.prototype.onPressed.call(this, f, isRunningForce && !this.wildcardTutorial);
};

WildcardBooster.prototype.hintAttempt = function () {
    if (cleverapps.environment.isSceneWithPreview() || cleverapps.config.editorMode) {
        return;
    }
    const noMoves = Game.currentGame.table.listMissed().length === 0;
    const activeCombo = Game.currentGame.combo && Game.currentGame.combo.level > 0;

    if (noMoves && activeCombo) {
        this.onUserInactive();
    }
};

WildcardBooster.prototype.makeUndo = function () {
    if (!this.wildcardTutorial) {
        cleverapps.user.earnHard(cleverapps.EVENTS.EARN.RETURN, this.getPrice().amount);
    }
    const card = Game.currentGame.open.pop();
    card.trigger("makeUndo");
};